<template>
  <div style="display: flex; width: fit-content; gap: 12px">
    <div v-if="showDeleted" class="tooltip" style="display: flex; flex-direction: column">
      <div style="display: flex; align-items: center; gap: 6px">
        <span class="tooltiptext"> {{ deletedText }}</span>
        <div class="flags flags-deleted-status" />
        <span style="color: #111827">
          Deleted
        </span>
      </div>
    </div>
    <div v-if="showPendingModeration" style="display: flex; flex-direction: column">
      <div style="display: flex; align-items: center; gap: 6px">
        <div class="flags flags-pending-status" />
        <span style="color: #6b7280">
          pending review
        </span>
      </div>
    </div>
    <div v-if="showBlocked" style="display: flex; flex-direction: column">
      <div style="display: flex; align-items: center; gap: 6px">
        <div class="flags flags-blocked-status" />
        <span style="color: #6b7280">
          Blocked
        </span>
      </div>
    </div>
    <div v-if="showEscalated" style="display: flex; flex-direction: column">
      <div style="display: flex; align-items: center; gap: 6px">
        <div class="flags flags-warning-status" />
        <span style="color: #6b7280">
          Escalated
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useMessageStore } from "%/apps/conversations/stores/message-store";
import dayjs from "dayjs";

export default {
  name: "MessageFlags",
  props: {
    messageId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    message() {
      return this.getMessage(this.messageId);
    },
    moderationStatus() {
      return this.message.moderationStatus;
    },
    deletedText () {
      let dateAndTime = dayjs.unix(this.message.timestampUpdated).format("DD MMMM YYYY THH:mm");
      return `You deleted this message on ${dateAndTime}`;
    },
    showEscalated() {
      return this.moderationStatus === "escalated";
    },
    showBlocked() {
      return this.moderationStatus === "blocked";
    },
    showPendingModeration() {
      return this.moderationStatus === "unknown";
    },
    showDeleted() {
      return this.message.status === "inactive";
    },
  },
  methods: {
    ...mapActions(useMessageStore, ["getMessage"]),
  },
};
</script>

<style scoped lang="scss">
</style>
